import { render, staticRenderFns } from "./DeliveredEvaluations.vue?vue&type=template&id=16b98665&"
import script from "./DeliveredEvaluations.vue?vue&type=script&lang=js&"
export * from "./DeliveredEvaluations.vue?vue&type=script&lang=js&"
import style0 from "./DeliveredEvaluations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports